module.exports = __webpack_public_path__ + "img/cowbell-circle-plus.a17fa07b.svg";